import { Suspense } from 'react';
import { Outlet, ScrollRestoration } from 'react-router';
import { LoadingBlock } from '@/components';
import { TopBar } from './TopBar';
import styles from './AppShell.module.css';

/** Authenticated frame: top bar + the routed area (fills the rest of the viewport). */
export function AppShell() {
  return (
    <div className={styles.shell}>
      <a href="#main" className={styles.skip}>
        Skip to content
      </a>
      <TopBar />
      <div className={styles.body}>
        <Suspense fallback={<LoadingBlock />}>
          <Outlet />
        </Suspense>
      </div>
      <ScrollRestoration />
    </div>
  );
}

/** Centered, scrollable page column for non-project pages (projects list, account, admin). */
export function ContentLayout() {
  return (
    <main id="main" className={styles.content}>
      <div className={styles.column}>
        <Suspense fallback={<LoadingBlock />}>
          <Outlet />
        </Suspense>
      </div>
    </main>
  );
}
